import React, { useState, useEffect } from "react";
import { Modal, Table, Spinner, Badge } from "react-bootstrap";
import config from "../../config/config";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import { formatDate } from "../../utils/formatDate";

const ProductStockModal = ({ show, handleClose, productId }) => {
  const [productList, setProductList] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchProductList = async () => {
    const token = getAuthToken();
    if (!token) return;

    try {
      setLoading(true);
      const response = await axios.get(
        `${config.API}/manager/productstockview/${productId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const result = response?.data;
      if (result?.success && Array.isArray(result?.product)) {
        setProductList(result.product);
      } else {
        setProductList([]);
      }
    } catch (err) {
      console.error("Error fetching product list:", err.message);
      setProductList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (productId && show) fetchProductList();
  }, [productId, show]);

  const renderStatus = (status) => {
    switch (status?.toLowerCase()) {
      case "pending":
        return <Badge bg="warning">{status}</Badge>;
      case "completed":
        return <Badge bg="success">{status}</Badge>;
      case "rejected":
        return <Badge bg="danger">{status}</Badge>;
      default:
        return <Badge bg="secondary">{status || "-"}</Badge>;
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg" className="font_family">
      <Modal.Header closeButton>
        <h5 className="fw-bold mb-0 fs-4">Product Stock Details</h5>
      </Modal.Header>

      <Modal.Body>
        {loading ? (
          <div className="d-flex justify-content-center py-5">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : productList.length > 0 ? (
          <div className="table-responsive">
            <Table bordered hover>
              <thead className="table-light">
                <tr>
                  <th>Product</th>
                  <th>Product Code</th>
                  <th>Stock</th>
                  <th>Produced</th>
                  <th>Rejected</th>
                  <th>Recycled</th>
                  <th>Actual Quantity</th>
                  <th>Status</th>
                  <th>Last Updated</th>
                </tr>
              </thead>
              <tbody>
                {productList.map((item, index) => (
                  <tr key={index}>
                    <td>{item?.product?.name || "-"}</td>
                    <td>{item?.product?.product_code || "-"}</td>
                    <td>{item?.product?.stock ?? "-"}</td>
                    <td>{item?.quantity_produced ?? "-"}</td>
                    <td>{item?.quantity_rejected ?? "-"}</td>
                    <td>{item?.quantity_recycled ?? "-"}</td>
                    <td>{item?.actual_quantity ?? "-"}</td>
                    <td>{renderStatus(item?.status)}</td>
                    <td>{formatDate(item?.updated_at)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ) : (
          <div className="text-center text-muted py-5">
            No product data found.
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ProductStockModal;